<template>
  <div class="container">
    <el-card shadow="never" style="margin-bottom: 10px;">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: 'techAchievementList' }">技术成果列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>

    <el-form ref="techAchievementForm" :model="techAchievementForm" label-width="120px" label-position="right"
             :size="defaultFormItemSize" :rules="rules" @submit.native.prevent
    >
      <el-card shadow="never" style="margin-bottom: 10px;">
        <el-form-item label="技术服务成果" prop="techServiceAchievement">
          <el-input v-model="techAchievementForm.techServiceAchievement" placeholder="请输入技术服务成果" :maxlength="200" show-word-limit />
        </el-form-item>
        <el-form-item label="技术成果合作单位" prop="cooperationUnit">
          <el-input v-model="techAchievementForm.cooperationUnit" placeholder="请输入技术成果合作单位" :maxlength="200" show-word-limit />
        </el-form-item>
        <el-form-item label="科技特派员" prop="scienceTechnician">
          <el-input v-model="techAchievementForm.scienceTechnician" placeholder="请输入科技特派员" :maxlength="200" show-word-limit />
        </el-form-item>
        <el-form-item label="图片" prop="imageUrl">
          <el-upload
            class="upload-demo" name="uploadFile" :headers="getUploadHeaders"
            :action="getUploadActionUrl('/admin/app/techAchievement/upload')"
            :data="{fieldName: 'imageUrl', asImage: true}"
            :on-success="onImageUrlUploadSuccess"
            :on-remove="onImageUrlRemoveFile"
            :on-error="onUploadError"
            :show-file-list="true"
            :on-preview="handlePreview"
            :limit="1"
            :on-exceed="onUploadLimit"
            :file-list="fileList"
            list-type="picture">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="techAchievementForm.remark" type="textarea" placeholder="请输入备注" :rows="4" :maxlength="500" show-word-limit />
        </el-form-item>
      </el-card>

      <div class="form-button-group">
        <el-button type="primary" :size="defaultFormItemSize" @click="onSaveClick()" :loading="isLoading">{{ isAddMode ? '新增' : '保存' }}</el-button>
        <el-button type="default" :size="defaultFormItemSize" @click="onCancelClick()">取消</el-button>
      </div>
    </el-form>
    <el-image-viewer v-if="imgViewerVisible" :on-close="closeImgViewer" :url-list="imgList" />
  </div>
</template>

<script>
import { TechAchievementController } from '@/api';
import { mapGetters } from 'vuex';
// eslint-disable-next-line no-unused-vars
import rules from '@/utils/validate.js';
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';

export default {
  name: 'techAchievementForm',
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },
  props: {
    id: {
      default: undefined
    },
    mode: {
      type: String,
      default: 'update', // 'add' or 'update'
      validator: (value) => ['add', 'update'].includes(value)
    },
    closeVisible: {
      type: [Number, String],
      default: 0
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      localId: '',
      localMode: 'add',
      techAchievementForm: {
        id: undefined,
        techServiceAchievement: undefined,
        cooperationUnit: undefined,
        scienceTechnician: undefined,
        imageUrl: undefined,
        remark: undefined
      },
      rules: {
        techServiceAchievement: [
          { required: true, message: '请输入技术服务成果', trigger: 'blur' },
          { min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
        ],
        cooperationUnit: [
          { required: true, message: '请输入技术成果合作单位', trigger: 'blur' },
          { min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
        ],
        scienceTechnician: [
          { required: true, message: '请输入科技特派员', trigger: 'blur' },
          { min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
        ],
        remark: [
          { max: 500, message: '长度不能超过 500 个字符', trigger: 'blur' }
        ]
      },
      isLoading: false,
      fileList: [],
      imgViewerVisible: false,
      imgList: []
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    isAddMode () {
      return this.localMode === 'add';
    },
    title () {
      return this.isAddMode ? '新增技术成果' : '编辑技术成果';
    }
  },
  mounted () {
    this.initFromRoute();
  },
  watch: {
    '$route.query': {
      handler () {
        this.initFromRoute();
      },
      deep: true
    }
  },
  beforeRouteUpdate (to, from, next) {
    this.initFromRoute();
    next();
  },
  methods: {
    initFromRoute () {
      const query = this.$route.query;
      if (query.id) {
        this.resetForm();
        this.localId = query.id;
        this.localMode = 'update';
        this.loadData();
      } else if (query.mode === 'add') {
        this.resetForm();
        this.localMode = 'add';
      }
    },

    loadData () {
      this.isLoading = true;
      TechAchievementController.view(this, { id: this.localId }).then(res => {
        this.techAchievementForm = res.data;
        if (res.data.imageUrl) {
          let imageUrlDownloadParams = {
            id: res.data.id,
            fieldName: 'imageUrl',
            asImage: true
          };
          this.fileList = this.parseUploadData(res.data.imageUrl, imageUrlDownloadParams);
        }
      }).catch(e => {
        this.$message.error('加载技术成果详情失败');
      }).finally(() => {
        this.isLoading = false;
      });
    },
    handlePreview (file) {
      this.imgViewerVisible = true;
      this.imgList = [];
      this.imgList.push(file.url);
    },
    closeImgViewer () {
      this.imgViewerVisible = false;
    },
    onImageUrlUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.uploadPath = response.data.uploadPath;
        file.url = URL.createObjectURL(file.raw);
        this.fileList = fileList;
        this.techAchievementForm.imageUrl = this.fileListToJson(fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    onImageUrlRemoveFile (file, fileList) {
      this.fileList = fileList;
      this.techAchievementForm.imageUrl = this.fileListToJson(fileList);
    },
    onUploadError (e, file, fileList) {
      this.$message.error('上传失败');
    },
    onUploadLimit (file, fileList) {
      this.$message.error('最多只能上传1个文件');
    },
    onSaveClick () {
      this.$refs.techAchievementForm.validate((valid) => {
        if (valid) {
          this.isLoading = true;
          let params = {
            techAchievementDto: {
              id: this.techAchievementForm.id,
              techServiceAchievement: this.techAchievementForm.techServiceAchievement,
              cooperationUnit: this.techAchievementForm.cooperationUnit,
              scienceTechnician: this.techAchievementForm.scienceTechnician,
              imageUrl: this.techAchievementForm.imageUrl,
              remark: this.techAchievementForm.remark
            }
          };

          const savePromise = this.isAddMode
            ? TechAchievementController.add(this, params)
            : TechAchievementController.update(this, params);

          savePromise.then(res => {
            this.$message.success(this.isAddMode ? '新增成功' : '保存成功');
            this.onCancelClick();
          }).catch(e => {
            this.$message.error(e.msg || (this.isAddMode ? '新增失败' : '保存失败'));
          }).finally(() => {
            this.isLoading = false;
          });
        } else {
          return false;
        }
      });
    },
    onCancelClick () {
      // 返回技术成果列表页面
      this.$router.push({ name: 'techAchievementList' });
    },
    resetForm () {
      this.techAchievementForm = {
        id: undefined,
        techServiceAchievement: undefined,
        cooperationUnit: undefined,
        scienceTechnician: undefined,
        imageUrl: undefined,
        remark: undefined
      };
      this.fileList = [];
      if (this.$refs.techAchievementForm) {
        this.$refs.techAchievementForm.clearValidate();
      }
    }
  }
}
</script>

<style scoped>
.container {
  padding: 20px;
}

.form-button-group {
  margin-top: 20px;
  text-align: center;
}
</style>
